/**
 * BD bulk history (まとめて履歴作成): draft form fields after modal 保険証資格取得日 = X.
 * Mirrors backend PatientService BD split helpers for on-screen consistency before 登録.
 */

import type { PatientFormData } from '@pages/main/patient/types';
import {
  normalizeHistoryYmd as ymd,
  subOneDayYmd,
} from '@pages/main/patient/utils/patientHistoryHelpers';
import { computeSinglePatientInformationHistoryNewAvailableToYmd } from './patientInfoSingleHistoryBd';

export interface BulkHistoryBdDraftAdjustments {
  healthInsuranceQualificationDate: string;
  healthInsuranceExpirationDate: string;
  /** New 受診者 row `available_to` (YYYY-MM-DD); empty string = open end */
  patientInformationAvailableTo: string;
  medicalAidApplicationStartDate: string;
  medicalAidApplicationEndDate: string;
}

export function computeBulkHistoryBdDraftAdjustments(
  patientData: PatientFormData,
  qualificationDateYmd: string,
): BulkHistoryBdDraftAdjustments {
  const x = ymd(qualificationDateYmd);
  const cards = patientData.health_insurance_cards ?? [];
  const currentCard = cards.find(c => c.is_current) ?? cards[0];

  let minQual = '';
  for (const c of cards) {
    const q = ymd(c.qualification_date);
    if (q && (!minQual || q < minQual)) {
      minQual = q;
    }
  }

  let healthInsuranceQualificationDate = x;
  let healthInsuranceExpirationDate = '';
  if (cards.length === 1 && ymd(currentCard?.qualification_date)) {
    const f = ymd(currentCard!.qualification_date);
    if (x < f) {
      healthInsuranceExpirationDate = subOneDayYmd(f);
    }
  } else if (cards.length > 1) {
    if (minQual && x < minQual) {
      healthInsuranceExpirationDate = subOneDayYmd(minQual);
    }
  }

  const patientInformationAvailableTo = computeSinglePatientInformationHistoryNewAvailableToYmd(
    patientData,
    x
  );

  const aids = (patientData.medical_aids ?? []).filter(a => a.insurer_type_id !== 1);
  const currentMa = aids.find(a => a.is_current) ?? aids[0];
  let minAidStart = '';
  for (const a of aids) {
    const s = ymd(a.application_start_date);
    if (s && (!minAidStart || s < minAidStart)) {
      minAidStart = s;
    }
  }
  let medicalAidApplicationStartDate = x;
  let medicalAidApplicationEndDate = '';
  if (aids.length === 1 && ymd(currentMa?.application_start_date)) {
    const s = ymd(currentMa!.application_start_date);
    if (x < s) {
      medicalAidApplicationEndDate = subOneDayYmd(s);
    }
  } else if (aids.length > 1) {
    if (minAidStart && x < minAidStart) {
      medicalAidApplicationEndDate = subOneDayYmd(minAidStart);
    }
  }

  return {
    healthInsuranceQualificationDate,
    healthInsuranceExpirationDate,
    patientInformationAvailableTo,
    medicalAidApplicationStartDate,
    medicalAidApplicationEndDate,
  };
}
